export default __webpack_public_path__ + "static/media/CH4NGEnergy Logo.6e2c7dd8.jpg";